import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AudienceEnum, UserTypeEnum } from '@lon/mathnation-suit/requests';
import { ProfileTypeEnum } from '@lon/shared/enums';
import { GetLookUpRolesQuery } from '@lon/shared/requests';
import { Permission } from '@lon/shared/types';

export interface AuthUser {
  districtId: string;
  schoolIds: string[];
  firstName: string;
  lastName: string;
  userType: UserTypeEnum;
  userId: string;
  gradeLevel: string;
  permissions?: Permission[];
  preferences: string;
  type: string;
  state: string;
  userRoles: GetLookUpRolesQuery['lookupRoles'];
  impersonated: boolean;
}

export interface AuthState {
  user: AuthUser;
  audience: AudienceEnum;
  originalUser: AuthUser | null;
  loading: boolean;
  isLoggedIn: boolean;
  profileType?: ProfileTypeEnum;
  contentGroups: string[] | null;
}

const initialState: AuthState = {
  loading: true,
  isLoggedIn: false,
  audience: AudienceEnum.Teacher,
  user: {} as any,
  /* Used for impersonation feature */
  originalUser: null,
  contentGroups: null,
};

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth(state, { payload }: PayloadAction<Partial<AuthState>>) {
      if (payload.audience) {
        state.audience = payload.audience;
      }

      if (payload.user !== undefined) {
        state.user = { ...state.user, ...payload.user };
      }

      if (payload.profileType !== undefined) {
        state.profileType = payload.profileType;
      }

      if (payload.originalUser !== undefined) {
        state.originalUser =
          payload.originalUser === null ? null : { ...payload.originalUser };
      }

      if (payload.loading !== undefined) {
        state.loading = payload.loading;
      }

      if (payload.isLoggedIn !== undefined) {
        state.isLoggedIn = payload.isLoggedIn;
      }

      if (payload.contentGroups !== undefined) {
        state.contentGroups = payload.contentGroups;
      }
    },
  },
});

export const { actions, reducer } = auth;
